import { memo } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { isAcceptableToDrop } from "@circle-react-shared/BuilderUI/Helpers/droppableAcceptsDraggable";
import type { BlockCategoryName } from "@circle-react-shared/BuilderUI/constants/BlockCategories";

export interface DroppableAreaProps {
  accepts: BlockCategoryName[];
  isOver: boolean;
  rejects: BlockCategoryName[];
}

export const DropArea = memo(
  ({ isOver, accepts, rejects }: DroppableAreaProps) => {
    const draggingTemplate = useBuilderStore(state => state.draggingTemplate);

    const categories = draggingTemplate
      ? (draggingTemplate.meta.category ?? [])
      : [];

    const isAcceptable = isAcceptableToDrop({ accepts, categories, rejects });

    return (
      <div
        data-drop-area
        className={classNames(
          "builder-ui-drop-area wb-h-[1rem] wb-border-primary wb-w-full wb-rounded wb-border-2 wb-border-dashed wb-p-2",
          {
            ["wb-bg-blue-400"]: isOver && isAcceptable,
            ["wb-bg-red-400"]: isOver && !isAcceptable,
          },
        )}
      />
    );
  },
);

DropArea.displayName = "DropArea";
